/* eslint-disable react/prop-types */
import React from "react";
import { motion } from "framer-motion";
import { IMAGE_URL } from "../../../constants";
import { Link } from "react-router-dom";

const ProjectFlipCard = ({ project }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const maxVisible = 3;
  const teamMembers = project?.teammembers || [];
  const extraCount = teamMembers.length - maxVisible;
  const visibleMembers = teamMembers.slice(0, maxVisible);
  const extraMembers = teamMembers.slice(maxVisible);

  return (
    <Link to={project?.link} target="_blank" rel="noopener noreferrer">
      <div
        className="relative w-full h-full overflow-hidden cursor-pointer aspect-square"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Front - Project Cover */}
        <img
          src={`${IMAGE_URL}/${project?.image}`}
          alt={project?.name}
          className="object-cover w-full h-full rounded-lg shadow-lg"
        />

        {/* Back - Overlay on Hover */}
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: isHovered ? "0%" : "100%" }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="absolute inset-0 flex flex-col justify-between w-full h-full p-4 text-white bg-indigo-900/95 rounded-lg shadow-lg"
        >
          {/* Project Info */}
          <div>
            <h3 className="text-lg font-semibold">{project?.name}</h3>
            <p className="mt-1 text-sm text-gray-200 line-clamp-3">
              {project?.description}
            </p>
          </div>

          {/* Team Members */}
          {teamMembers.length > 0 && (
            <div className="mt-3">
              <h4 className="text-sm font-bold mb-1">Team Members</h4>
              <div className="flex items-center -space-x-2">
                {visibleMembers.map((member) => (
                  <div
                    key={member.id}
                    className="w-8 h-8 rounded-full border-2 border-white overflow-hidden"
                    title={member.name + (member.is_leader ? " (Leader)" : "")}
                  >
                    <img
                      src={`${IMAGE_URL}/${member.image}`}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
                {extraCount > 0 && (
                  <div
                    className="w-8 h-8 rounded-full border-2 border-white bg-gray-700 text-xs text-white flex items-center justify-center font-semibold"
                    title={extraMembers
                      .map((m) => m.name + (m.is_leader ? " (Leader)" : ""))
                      .join(", ")}
                  >
                    +{extraCount}
                  </div>
                )}
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </Link>
  );
};

export default ProjectFlipCard;
